module.exports = __webpack_public_path__ + "img/child_place.d16d78d8.png";